import type React from 'react';

export function SkeletonDetail() {
  return (
    <div style={{ padding: '2.25rem 2.5rem', maxWidth: 900 }}>
      <div
        style={{
          width: 120,
          height: 14,
          background: 'var(--line-soft)',
          borderRadius: 8,
          marginBottom: '1rem',
        }}
      />
      <div
        style={{
          width: '50%',
          height: 24,
          background: 'var(--line-soft)',
          borderRadius: 8,
          marginBottom: '2rem',
        }}
      />
      {[1, 2].map((i) => (
        <div
          key={i}
          style={{
            background: '#fff',
            borderRadius: 14,
            border: '1px solid var(--line)',
            padding: '1.25rem 1.5rem',
            height: 100,
            marginBottom: '1rem',
          }}
        >
          <div
            style={{
              width: '30%',
              height: 14,
              background: 'var(--line-soft)',
              borderRadius: 8,
              marginBottom: '0.75rem',
            }}
          />
          <div style={{ width: '60%', height: 12, background: 'var(--soft)', borderRadius: 8 }} />
        </div>
      ))}
    </div>
  );
}

export const inputCss: React.CSSProperties = {
  padding: '0.5rem 0.6rem',
  border: '1px solid var(--line)',
  borderRadius: 10,
  fontSize: '0.85rem',
  outline: 'none',
};

export const primaryBtn: React.CSSProperties = {
  background: 'var(--green)',
  color: '#fff',
  border: 'none',
  borderRadius: 999,
  padding: '0.45rem 1rem',
  fontSize: '0.8rem',
  fontWeight: 600,
  cursor: 'pointer',
};

export const secondaryBtn: React.CSSProperties = {
  background: '#fff',
  color: 'var(--muted)',
  border: '1px solid var(--line)',
  borderRadius: 999,
  padding: '0.45rem 1rem',
  fontSize: '0.8rem',
  cursor: 'pointer',
};

export const smallBtn: React.CSSProperties = {
  background: 'transparent',
  color: 'var(--green)',
  border: '1px solid var(--green)',
  borderRadius: 999,
  padding: '0.25rem 0.75rem',
  fontSize: '0.75rem',
  fontWeight: 600,
  cursor: 'pointer',
};

export const linkBtn: React.CSSProperties = {
  background: 'none',
  border: 'none',
  color: 'var(--muted)',
  cursor: 'pointer',
  fontSize: '0.875rem',
  marginBottom: '0.5rem',
  display: 'block',
  padding: 0,
};

export const modalOverlay: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'var(--overlay)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 100,
};

export const modalStyle: React.CSSProperties = {
  background: '#fff',
  borderRadius: 14,
  padding: '1.5rem',
  minWidth: 360,
  maxWidth: 440,
};
